var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-image"},[_c('div',{staticClass:"holder"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})])]),_c('div',{staticClass:"bg-top"})])
}
var staticRenderFns = []

export { render, staticRenderFns }